import React from 'react';
import ArrowBottom from '../icons/ArrowBottom';

const DownArrow = (props) => {
	return (
		<button className="to-bottom" aria-label="Go to next section">
			{/* <a href={`#${props.link}`} className="no-style"> */}
			{/* <i className="fa fa-arrow-down fa-3x icon" /> */}
			<ArrowBottom />
			{/* </a> */}
		</button>
	);
};

export default DownArrow;



// WEBPACK FOOTER //
// ./src/components/common/DownArror.js